export default __webpack_public_path__ + "static/media/990.bb83254d.jpg";